//#region MapoCrud
var mapoCRUD = {
    events: {
        changed: 'mapoCRUD-changed-all-inputs'
    },
    changeValue: function ($input) {
        let val;
        let isDDL = $input.hasClass('kdr-dropdown-w-search-item_selected')
        let isMDDL = $input.closest('.kdr-dropdown-w-search_multi').length > 0
        if (isDDL) {
            if (isMDDL) {
                val = []

                $($input.valExtended()).each((i, e) => {
                    let x = $input.closest('.kdr-dropdown-w-search_multi')
                        .find('.items_selected-text-item[data-value="' + $.escapeSelector(e) + '"]')
                        .text().trim()
                    val.push(x)
                })

            } else {
                val = $input.text().trim()
            }
        } else {
            val = $input.valExtended()
        }


        let $parent = null
        if ($input.closest('.modal').length > 0) {
            $parent = $input.closest('.modal')
        } else {
            $parent = $(document)
        }

        let pattern = /si-([\dA-Za-z-]+)/i
        let id = $input.attr('class').match(pattern)[1]
        let targets = []//
        if ($input.hasClass("kdr-grid-checkbox-list")) {
            targets = $parent.find('.ti-' + id)
        }
        else if ($input.attr('type') != 'radio') {
            targets = $parent.find('.kdr-grid-item-update .ti-' + id)
        } else {
            targets = $parent.find('.kdr-grid-item-update .ti-' + id + '[value="' + val + '"]')
        }


        /* SEKCJA KOWALSKIEGO */
        let transformFunctionPattern = /transform-function-([\dA-Za-z-]+)/i
        let transformFunctionMatch = $input.attr('class').match(transformFunctionPattern)
        let transformFunction = (a) => { return a; }
        if (transformFunctionMatch != null) {
            let functionName = transformFunctionMatch[1]
            transformFunction = window[functionName]
        }
        /* /SEKCJA KOWALSKIEGO */

        for (var i = 0; i < targets.length; i++) {
            let $target = targets.eq(i)

            if ($target.attr('disabled') == 'disabled' && !$target.hasClass('even-disabled-ti')) {
                continue
            }

            let valueToSet;

            if (isDDL && !isMDDL) {
                let bsDropdown = $target.data("bs.dropdown")
                let $menu = undefined

                if (bsDropdown == undefined) {
                    $menu = $('#' + $target.data('target'))
                } else {
                    let menu = $target.data("bs.dropdown")?._menu
                    $menu = menu != undefined ? $(menu) : $target.closest('.kdr-dropdown-w-search').find('.kdr-dropdown-w-search-menu')
                }

                valueToSet = $menu.find('.kdr-dropdown-w-search-item:contains("' + val + '")').data('value')

                if (valueToSet == undefined) {
                    continue
                }
            } else if (isMDDL) {
                $(val).each((i, e) => {
                    let x = $target.closest('.modal-body')
                        .find('.kdr-dropdown-w-search-item-text').filter(function () {
                            return $(this).text().trim() === e;
                        })
                        .closest('.kdr-dropdown-w-search-item')
                        .data('value')
                    if (x != undefined) {
                        if (valueToSet == undefined) {
                            valueToSet = []
                        }

                        kdrDropdown.clearDropdown($target.closest('.kdr-dropdown-w-search'))
                        valueToSet.push(x)
                    }
                })

                if (val.length == 0) {
                    kdrDropdown.clearDropdown($target.closest('.kdr-dropdown-w-search'))
                }

            } else {
                valueToSet = transformFunction(val)
            }

            $target.valExtended(valueToSet, undefined, false)
            disabler.checkChildren($target)

            if (i == targets.length - 1) {
                $parent.trigger({
                    type: mapoCRUD.events.changed,
                    input: $input
                })
            }
        }
        return targets
    }
}

//PRE mapoCRUD
$(document).on('input change', '.kdr-grid .s:not([disabled="disabled"]):not(.kdr-custom-radio):not(.s-w-change)', function (e) {
    mapoCRUD.changeValue($(this))
})
$(document).on('input change', '.kdr-grid .s-w-change.s:not([disabled="disabled"]):not(.kdr-custom-radio)', function (e) {
    let $t = $(this)

    if (e.type == 'input' && $t.attr('type') == 'checkbox') { //fixme sprawidzc czemu to sie odpala na CB
        console.error('this shouldn\'t happen')
        console.log(this)
        console.log(e)
        return false
    }

    let $targets = mapoCRUD.changeValue($t)
    $targets.each((i, e) => $(e).change())
})
$(document).on('click', '.kdr-grid .kdr-custom-radio.s:not([disabled="disabled"])', function () {
    mapoCRUD.changeValue($(this))
})

//#endregion MapoCrud